import axios from "axios";
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

const buy_partnership__form = document.querySelector('.buy-partnership__form');
const file_name_el = document.querySelector('.buy-partnership-field__name');

if (buy_partnership__form) {
    document.querySelectorAll('[name="payment_plan"]').forEach(item => item.addEventListener('change', function () {
        document.querySelectorAll('.buy-partnership__part').forEach(el => el.classList.toggle('active'));

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }));

    buy_partnership__form?.addEventListener('submit', function (e) {
        e.preventDefault();

        const _el = this;

        if (_el.classList.contains('active')) {
            return false;
        }

        _el.classList.add('sending');

        const partners_tax_exist = _el.querySelector('[name="partners_tax_exist"]').value;
        let is_error = false;
        let term_ids = [];

        const fields = {
            payment_plan: '[name="payment_plan"]',
            company_name: '[name="company_name"]',
            website_url: '[name="website_link"]',
            contact_name: '[name="contact_name"]',
            contact_email: '[name="contact_email"]',
            short_description: '[name="short_description"]',
            file: 'input[name="file"]',
        };

        for (const [key, selector] of Object.entries(fields)) {
            const input = _el.querySelector(selector);

            input?.classList.remove('error');

            let value;

            if (key === 'payment_plan') {
                value = _el.querySelector('[name="payment_plan"]:checked')?.value || '';
            } else if (key === 'file') {
                value = input.files?.[0] || null;
            } else {
                value = input.value.trim();
            }

            if (!value) {
                is_error = true;
                input?.classList.add('error');
            }
        }

        if (partners_tax_exist) {
            const dropdown_el = _el.querySelector('.buy-partnership-field.dropdown');
            term_ids = Array.from(dropdown_el.querySelectorAll('.dropdown__item.active'))
                .map(el => el.getAttribute('data-value'))
                .filter(v => v !== "");

            if (term_ids.length === 0) {
                is_error = true;
                dropdown_el.classList.add('error');
            } else {
                dropdown_el.classList.remove('error');
            }
        }

        if (is_error) {
            _el.classList.remove('sending');
            return false;
        }

        const formData = new FormData();
        formData.append('payment_plan', _el.querySelector('[name="payment_plan"]:checked').value);
        formData.append('company_name', _el.querySelector('[name="company_name"]').value.trim());
        formData.append('website_link', _el.querySelector('[name="website_link"]').value.trim());
        formData.append('contact_name', _el.querySelector('[name="contact_name"]').value.trim());
        formData.append('contact_email', _el.querySelector('[name="contact_email"]').value.trim());
        formData.append('short_description', _el.querySelector('[name="short_description"]').value.trim());
        formData.append('company_logo', _el.querySelector('input[name="file"]').files[0]);

        if (partners_tax_exist) {
            term_ids.forEach(id => {
                formData.append('partners_terms[]', id);
            });
        }

        axios.post(
            '/wp-json/sell_data/v1/partners',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(response => {
            const data = response.data;
            console.log(data);

            if (data.success) {
                Toastify({
                    text: 'Payment link created successfully',
                    style: {
                        background: "green",
                    }
                }).showToast();

                window.location.replace(data.payment_link);
            }
            else {
                Toastify({
                    text: data.message,
                    style: {
                        background: "red",
                    }
                }).showToast();
            }
        })
        .catch(error => {
            console.log(error);

            Toastify({
                text: 'Something went wrong',
                style: {
                    background: "red",
                }
            }).showToast();
        })
            .finally(function () {
                _el.classList.remove('sending');
            });
    });

    buy_partnership__form.querySelector('[name="file"]').addEventListener('change', function() {
        const file = this.files[0];

        if (file) {
            file_name_el.textContent = file.name;
        } else {
            file_name_el.textContent = '';
        }
    });
}